<template>
    <div v-if="locked" :class="{ locked: true, readOnly: readOnly }">locked until: {{ lockedUntil }} / owner: {{ lockedBy }}</div>
</template>

<script>
export default {
    props: {
        lockDetails: { required: true, type: Object },
        locked: { required: true, type: Boolean },
        readOnly: { type: Boolean, default: true }
    },
    computed: {
        lockedUntil() {
            if (!this.lockDetails || !this.lockDetails.deadline) return "";
            const date = new Date(this.lockDetails.deadline * 1000);
            return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        },
        lockedBy() {
            if (!this.lockDetails || !this.lockDetails.lockedBy) return "";
            return `${this.lockDetails.lockedBy.firstname} ${this.lockDetails.lockedBy.lastname}`;
        }
    }
};
</script>

<style lang="scss" scoped>
div {
    &.readOnly {
        background-color: orange;
    }
    &.locked {
        background-color: darkred;
    }
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    color: white;
}
</style>



// WEBPACK FOOTER //
// lock-status.vue?4641d72a